export const useGeneralStore = defineStore('general', {
  state: () => {
    return {
      langs: [
        { id: 'en', text: useT('event.language.english'), icon: 'custom/flag-en' },
        { id: 'es', text: useT('event.language.spanish'), icon: 'custom/flag-es' },
        { id: 'fr', text: useT('event.language.french'), icon: 'custom/flag-fr' },
        { id: 'cs', text: useT('event.language.czech'), icon: 'custom/flag-cz' },
        // { id: 'sk', text: useT('event.language.slovak'), icon: 'custom/flag-sk' },
        { id: 'de', text: useT('event.language.german'), icon: 'custom/flag-de' },
        { id: 'pl', text: useT('event.language.polish'), icon: 'custom/flag-pl' },
        { id: 'hu', text: useT('event.language.hungarian'), icon: 'custom/flag-hun' },
        { id: 'zh', text: useT('event.language.chinese'), icon: 'custom/flag-cn' },
        { id: 'pt', text: useT('event.language.portuguese'), icon: 'custom/flag-br' },
        { id: 'ja', text: useT('event.language.japanese'), icon: 'custom/flag-jp' },
        { id: 'it', text: useT('event.language.italian'), icon: 'custom/flag-it' },
      ],
      isBurgerMenuOpen: false,
      isNavigationHovered: false,
    };
  },

  getters: {
    getLang: (state) => (langId) => {
      return state.langs?.find((lang) => lang?.id === langId);
    },
    getLangs: (state) => {
      return (locale) => {
        // Czech is only offered as an event language for Czech-locale distributors.
        const isCzechDistributor = useWorkspaceStore()?.distributor?.locale === 'cs';
        const langs = state.langs.filter((lang) => lang.id !== 'cs' || isCzechDistributor);

        if (locale === 'cs') {
          const czechLangsOrder = ['cs', 'en', 'sk', 'pl', 'de', 'es', 'fr', 'hu'];
          return _sortBy(langs, (lang) => czechLangsOrder.indexOf(lang.id));
        }

        return langs;
      };
    },
  },
});
